import { RejectedByProfessionals } from 'presentation/app/modules/Reports/pages/activities/rejected-by-professionals';
import React from 'react';

export const MakeRejectedByProfessionals: React.FC = () => {
  return <RejectedByProfessionals />;
};
